import React from "react"
import { Link } from "gatsby"
import S from "./StyledAboutSection"

const AboutSection = () => {
  return (
    <S.AboutSectionWrapper>
      <p>
        Jesteśmy firmą specjalizującą się w nadzorze budowlanym oraz kierowaniu
        robotami budowlanymi, a naszą misją jest zapewnienie profesjonalnej
        obsługi naszych klientów. Właściciel firmy, <Link to="https://www.linkedin.com/in/dawid-mroczek-7ba0aa1a7" target="_blank">mgr inż. Dawid Mroczek</Link>, to
        absolwent wydziału Budownictwa i Inżynierii Środowiska oraz kierownik
        należący do <Link to="https://zoiib.pl/" target="_blank">Zachodniopomorskiej Okręgowej Izby Inżynierów Budownictwa</Link>.
        Posiada on uprawnienia do kierowania robotami bez ograniczeń w
        specjalności konstrukcyjno-budowlanej, inżynieryjnej drogowej oraz
        inżynieryjnej kolejowej w zakresie kolejowych obiektów budowlanych.
      </p>
      <p>
        Dawid Mroczek zdobywał doświadczenie z zakresu kierowania robotami
        pracując w międzynarodowych firmach budowlanych, co pozwoliło mu na
        zdobycie szerokiej wiedzy oraz umiejętności niezbędnych do skutecznego
        zarządzania projektami budowlanymi. Jego pasją jest praca w branży
        budowlanej, co przekłada się na zaangażowanie w każde zlecenie, które
        podejmuje.
      </p>
      <p>
        W naszej firmie stawiamy na wysoką jakość usług oraz indywidualne
        podejście do każdego klienta. Dzięki temu, że jesteśmy specjalistami w
        zakresie nadzoru inwestorskiego oraz kierowania robotami budowlanymi,
        możemy zapewnić naszym klientom kompleksową obsługę na każdym etapie
        realizacji projektu. Zaufaj nam i skorzystaj z naszych usług, a
        przekonasz się, że profesjonalizm i pasja to nasze największe atuty.
      </p>
      <p>
        Jeśli poszukujesz doświadczonego kierownika budowy lub inspektora
        nadzoru inwestorskiego, firma NDA jest odpowiednim wyborem. Działamy
        głównie na terenie województw zachodniopomorskiego oraz lubuskiego, a
        nasze usługi świadczymy między innymi w Szczecinie, Stargardzie,
        Choszcznie, Barlinku, Gorzowie Wielkopolskim czy Drawsku Pomorskim.
      </p>
    </S.AboutSectionWrapper>
  )
}

export default AboutSection
